import { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { z } from 'zod';
import { useTypedPathParams } from '../../../../shared/fe/hooks/useTypedPathParams';
import { useLocation, useNavigate } from 'react-router';
import { ItemConfig, Switcher } from '../../layout/Switcher';
import { useMediaQuery } from '@mui/system';
import { Theme } from '@mui/material';

const pathParamsSchema = z.object({
	id: z.string(),
});

type Props = {
	warningsCount: number;
};

const JourneyViewSwitcher: FC<Props> = ({ warningsCount }) => {
	const navigate = useNavigate();
	const location = useLocation();
	const { id } = useTypedPathParams(pathParamsSchema);
	const matchDownSM = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'));

	const config = [
		matchDownSM
			? null
			: {
					item: 'ACTIVITY_MAP',
					onNavigate: () => {
						navigate(`/journeys/${id}/activity-map`);
					},
					title: <FormattedMessage id={'journey.view.activity-map'} />,
					isActive: () => /^\/journeys\/[^/]+\/activity-map$/.test(location.pathname),
				},
		{
			item: 'DETAIL',
			onNavigate: () => {
				navigate(`/journeys/${id}/detail`);
			},
			title: <FormattedMessage id={'journey.view.detail'} />,
			isActive: () => /^\/journeys\/[^/]+\/detail$/.test(location.pathname),
		},
		{
			item: 'WARNINGS',
			onNavigate: () => {
				navigate(`/journeys/${id}/warnings`);
			},
			title: <FormattedMessage id={'journey.view.warnings-board'} values={{ count: warningsCount }} />,
			isActive: () => /^\/journeys\/[^/]+\/warnings$/.test(location.pathname),
		},
		{
			item: 'PLANNING',
			onNavigate: () => {
				navigate(`/journeys/${id}/planning`);
			},
			title: <FormattedMessage id={'journey.view.planning'} />,
			isActive: () => /^\/journeys\/[^/]+\/planning$/.test(location.pathname),
		},
	].filter(Boolean) as ItemConfig<string>[];

	return <Switcher variant={'buttons'} config={config} />;
};

export { JourneyViewSwitcher };
